<template>
    <div class="container">
        <el-dialog
          :center="true"
          title=""
          :visible.sync="dialogTableVisible"
          append-to-body
          :modal-append-to-body="true"
          :close-on-click-modal="true"
          :lock-scroll="true"
          :z-index="3000"
          custom-class="word_dialog"
          @close="close"
        >
            <div class="word_title">
                {{ word_data.word }}
            </div>
            <div v-if="word_data.origin" class="word_origin_box">
                <div class="word_origin_title">以下展示该词原型的释义: {{ word_data.origin }}</div>
            </div>
            <div class="word_yb">
                <div class="word_yb_list">
                    <div>UK</div>
                    <div class="word_mar">{{ word_data.symUk }}</div>
                    <div><img src="@/assets/image/bofang.png" class="word_audio" @click="play(1)"></div>
                    <audio ref="audio" :src="word_data.symUkSoundLink"></audio>
                </div>
                <div class="word_yb_list">
                    <div>US</div>
                    <div class="word_mar">{{ word_data.symUs }}</div>
                    <div><img src="@/assets/image/bofang.png" class="word_audio" @click="play(2)"></div>
                    <audio ref="audio2" :src="word_data.symUsSoundLink"></audio>
                </div>
            </div>
            <el-divider></el-divider>
            <div class="word_content">
                <div class="word_container">
                    <div class="word_row_title">词典释义</div>
                    <div>
                        <div v-for="(item, index) in word_data.means" :key="index">
                            <div class="word_means_list">{{ item.m }}</div>
                        </div>
                    </div>
                </div>
                <div class="word_container">
                    <div class="word_row_title">参考例句</div>
                    <div>
                        <div v-for="(item, index) in word_data.sentences" :key="index">
                            <div class="word_means_list">{{ item.eg }}</div>
                            <!-- 中文翻译已屏蔽 -->
                        </div>
                    </div>
                </div>
            </div>
            <div class="flex">
                <div @click="dialogTableVisible = false" class="word_cancel">返回</div>
                <div @click="add" class="add_word" v-if="is_book == 0">加入单词本</div>
                <div class="add_complete" v-else>已添加</div>
            </div>
        </el-dialog>
    </div>
  </template>

  <script>
  export default {
    name: "word",
    data() {
      return {
        dialogTableVisible:false,
        word_text: '',
        is_book: 0,
        word_data: {}
      };
    },
    created() {
    },
    methods: {
        /**
         * 检测内容是否为中文
         * @param {string} content - 要检测的内容
         * @return {boolean} 是否为中文内容
         */
        isChineseContent(content) {
            if (!content) return false;
            // 检测是否包含中文字符
            return /[\u4e00-\u9fa5]/.test(content);
        },
        /**
         * 过滤内容，只保留英文、数字，去掉中文和单词开头末尾的符号
         * @param {string} content - 原始内容
         * @return {string} 过滤后的内容
         */
        filterChineseContent(content) {
            if (!content) return content;
            // 先移除中文字符
            let filtered = content.replace(/[\u4e00-\u9fa5]/g, '');
            // 移除单词开头和末尾的符号，保留中间的空格和标点
            filtered = filtered.replace(/^[^\w\s]+|[^\w\s]+$/g, '');
            // 清理多余空格
            return filtered.trim().replace(/\s+/g, ' ');
        },
        // 获取学习时长
        getWord() {
            // 检测是否为中文内容，如果是中文则不调用接口
            if (this.isChineseContent(this.word_text)) {
                return;
            }

            this.$axios.post("word.word_book/get_word",{
                word: this.word_text
            }).then((res) => {
                const msg = (res && (res.msg || (res.data && res.data.msg))) || "查询失败";
                if (res.code == 1) {
                    console.log('res',res);
                    if(res.data.data.dict == null) {
                        this.$message.error("词典中未找到该单词");
                        this.dialogTableVisible=false;
                    } else {
                        this.dialogTableVisible=true;
                        this.word_data = res.data.data.dict;
                        this.is_book = res.data.data.is_book
                        console.log('this.word_data',this.word_data);
                        this.autoPlayPronunciation();
                    }
                } else {
                this.$message.error(msg);
                this.dialogTableVisible=false;
                }
            }).catch((err) => {
                console.log(err);
                this.$message.error((err && err.msg) || "请求失败");
                this.dialogTableVisible=false;
            });
        },
        close(){
            this.word_text = ''
            this.word_data = {}
        },
        autoPlayPronunciation() {
            this.$nextTick(() => {
                const ukLink = this.word_data && this.word_data.symUkSoundLink;
                const usLink = this.word_data && this.word_data.symUsSoundLink;
                const audioRef = ukLink ? this.$refs.audio : (usLink ? this.$refs.audio2 : null);

                if (!audioRef) {
                    return;
                }

                const playPromise = audioRef.play();
                if (playPromise && typeof playPromise.catch === 'function') {
                    playPromise.catch(() => {});
                }
            });
        },
        play(type){
            if(type == 1) {
                if (this.$refs.audio && this.word_data.symUkSoundLink) {
                    this.$refs.audio.play(); //提示音效
                }
            }
            if(type == 2) {
                if (this.$refs.audio2 && this.word_data.symUsSoundLink) {
                    this.$refs.audio2.play(); //提示音效
                }
            }
        },
        add(){
            var params = {
                word: this.word_text
                .toLowerCase()
                .replace(/[^\u4e00-\u9fa5\w]/g, "")
                .trim(),
            };
            this.$axios
                .post("word.user_word_book/add", params)
                .then((res) => {
                console.log(res);
                if (res.code == 1) {
                    this.$message.success("加入单词本成功");
                    this.is_book = 1;
                } else {
                    this.$message.error(res.msg);
                }
                })
                .catch((err) => {
                    console.log(err);
                    this.$message.error(err.msg);
                });
        }
    },
  };
  </script>

  <style>
  .word_dialog {
    width: 90%;
    max-width: 1000px;
  }

  .word_dialog .el-dialog__body {
    max-height: 70vh;
    overflow-y: auto;
  }

  .dialog_box {
    width: 90%;
    max-width:1000px;
  }
  .word_title {
    color: #f6704b;
    font-size: 30px;
  }
  .add_complete {
    color: #f6704b;
    font-size: 16px;
    cursor: pointer;
  }
  .word_yb {
    display: flex;
    align-items: center;
    margin-top: 10px;
  }
  .word_yb_list {
    display: flex;
    width: 50%;
    align-items: center;
  }
  .word_mar {
    margin: 0 8px;
  }
  .word_audio {
    width: 20px;
    height: 20px;
    cursor: pointer;
  }
  .word_content {
    display: flex;
    flex-direction: row;
    margin: 20px 0;
    height: 300px;
    overflow: auto;
  }
  .word_container {
    width: 50%;
  }
  .word_row_title {
    font-size: 16px;
    color: #999999;
  }
  .word_means_list {
    font-size: 16px;
    line-height: 30px;
    margin: 8px 0;
  }
  .word_origin_box {
    margin-top: 16px;
    padding-top: 12px;
    border-top: 1px dashed #e6e6e6;
  }
  .word_origin_title {
    font-size: 14px;
    line-height: 24px;
    color: #666666;
  }
  .flex {
    display: flex;
    justify-content: space-between;
    margin: 10px 20px;
  }
  .word_cancel {
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #999999;
    color: #999999;
    width: 120px;
    line-height:40px;
    border-radius: 25px;
    cursor: pointer;
    font-size: 16px;
    letter-spacing: 2px;
  }
  .add_word {
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #f6704b;
    color: #ffffff;
    background: #f6704b;
    width: 120px;
    line-height:40px;
    border-radius: 25px;
    cursor: pointer;
  }
  </style>






